import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import ViewGoalDiets from "../dietPackage/ViewGoalDiets";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { dietPackageGet } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const DietFetchAndAssign = ({
  userInfoData,
  prevFormValues,
  dataValues,
  tdeeValues,
  setDataValues,
  recExtInputs,
  setRecExtInputs,
  isSubmit,
  setIsSubmit,
}) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.common);

  const { selBodyType, selDietPreference } = prevFormValues || {};
  const { dietPackData } = dataValues || {};
  const [finalCal, setFinalCal] = useState(0);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setIsSubmit(false);

    setRecExtInputs((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  function getDietPack(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: dietPackageGet,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (
      selBodyType?.label &&
      (selBodyType.label.toLowerCase().includes("gain") ||
        selBodyType.label.toLowerCase().includes("lean") ||
        selBodyType.label.toLowerCase().includes("loose"))
    ) {
      if (selBodyType.label.toLowerCase().includes("gain")) {
        setRecExtInputs((prev) => ({
          ...prev,
          dietTpe: "gain",
        }));
      } else {
        setRecExtInputs((prev) => ({
          ...prev,
          dietTpe: "lean",
        }));
        setIsSubmit(true);
      }
    } else {
      setRecExtInputs((prev) => ({
        ...prev,
        dietTpe: "",
      }));
      setIsSubmit(true);
    }
  }, []);

  useEffect(() => {
    if (recExtInputs.isRecomended) {
      setRecExtInputs((prev) => ({
        ...prev,
        isExtreame: false,
      }));
    } else if (recExtInputs.isExtreame) {
      setRecExtInputs((prev) => ({
        ...prev,
        isRecomended: false,
      }));
    }
  }, [recExtInputs.isRecomended, recExtInputs.isExtreame]);

  useEffect(() => {
    if (recExtInputs.dietTpe) {
      if (
        selBodyType?.value &&
        selDietPreference?.value &&
        (recExtInputs.isRecomended || recExtInputs.isExtreame)
      ) {
        const gainedLeanCalorie = recExtInputs.isRecomended
          ? parseFloat(selBodyType?.info?.recommended || 0)
          : recExtInputs.isExtreame
          ? parseFloat(selBodyType?.info?.extreme || 0)
          : 0;
        let tdeeCalories = parseFloat(tdeeValues || 0);
        let finalCal;

        if (recExtInputs.dietTpe === "gain") {
          finalCal = tdeeCalories + gainedLeanCalorie;
        } else {
          finalCal = tdeeCalories - gainedLeanCalorie;
        }

        setFinalCal(finalCal);

        const filters = {
          type1: selBodyType.value,
          type2: selDietPreference.value,
          status: "active",
          e_calories: finalCal || 0,
        };

        getDietPack(filters);
      }
    } else if (!recExtInputs.dietTpe) {
      if (selBodyType?.value && selDietPreference?.value) {
        const filters = {
          type1: selBodyType.value,
          type2: selDietPreference.value,
          status: "active",
          e_calories: tdeeValues || 0,
        };

        setFinalCal(tdeeValues);

        getDietPack(filters);
      }
    }
  }, [recExtInputs]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setDataValues((prevs) => ({
        ...prevs,
        dietPackData: data.data,
      }));
    } else {
      setDataValues((prevs) => ({
        ...prevs,
        dietPackData: [],
      }));
    }
  }, [data]);

  return (
    <div className="flex-col no-margin no-padding-top">
      {recExtInputs.dietTpe ? (
        <form className="formContainer">
          <div className="formInputsGrid threeGridSystem">
            <div className="formInputBox span3 check-input-not-bar flex-row">
              <Form.Check
                type="checkbox"
                name="isRecomended"
                className={`${recExtInputs.isRecomended ? "formError" : ""}`}
                style={{
                  cursor: "pointer",
                }}
                label={`${
                  recExtInputs.isRecomended ? "recommended" : "recommended"
                }`}
                checked={recExtInputs.isRecomended}
                onChange={onChangeInput}
              />

              <Form.Check
                type="checkbox"
                name="isExtreame"
                className={`${recExtInputs.isExtreame ? "formError" : ""}`}
                style={{
                  cursor: "pointer",
                }}
                label={`${recExtInputs.isExtreame ? "extreme" : "extreme"}`}
                checked={recExtInputs.isExtreame}
                onChange={onChangeInput}
              />
            </div>

            {recExtInputs.isRecomended || recExtInputs.isExtreame ? (
              <span className="info">Final Calorie: {finalCal}</span>
            ) : null}
          </div>
        </form>
      ) : null}

      {!recExtInputs.dietTpe ||
      (recExtInputs.dietTpe &&
        (recExtInputs.isRecomended || recExtInputs.isExtreame)) ? (
        <>
          {dietPackData?.length > 0 ? (
            <div className="fullWidthFlexCenter view-only-diet-days">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <ViewGoalDiets
                  isViewOnly={true}
                  rowData={dietPackData?.[0] || {}}
                />
              )}
            </div>
          ) : (
            <span className="info mt30">
              No Diet Package Found for the diet type <b>{selBodyType?.label}</b> and
              diet preference <b>{selDietPreference?.label}</b> and calorie <b>{finalCal}</b>{" "}
            </span>
          )}{" "}
        </>
      ) : null}
    </div>
  );
};

export default DietFetchAndAssign;
